export const NAV = [
  { label: "Firm", href: "#about" },
  { label: "Strategies", href: "#programs" },
  { label: "Careers", href: "#careers" },
  { label: "Vacancies", href: "#vacancies" },
  { label: "Insights", href: "#insights" },
  { label: "Contact", href: "#contact" },
];

export const STATS = [
  { value: "2026", label: "Established" },
  { value: "Independent", label: "100% Firm Capital" },
  { value: "Local", label: "Excellence" },
];

export const MARQUEE = [
  "PROPRIETARY CAPITAL", "S&P 500", "DISCRETIONARY", "FUTURES", "EQUITIES",
  "FX", "SYSTEMATIC", "COMMODITIES", "VOLATILITY",
];

export const MANIFESTO = [
  { n: "01", title: "Capital is a discipline", body: "We do not chase noise. Every position is an expression of conviction, sized with intent and defended with rigor. Risk is not the enemy of return — it is its architecture." },
  { n: "02", title: "The desk is a craft", body: "Great traders are made across years, not weekends. We invest in people the way we invest in markets: patiently, deliberately, and with an eye toward compounding." },
  { n: "03", title: "Edge is earned", body: "There is no shortcut past preparation. Our traders arrive early, read deeply, and treat every session as a rehearsal for the moments that matter most." },
  { n: "04", title: "Partnership over hierarchy", body: "We back conviction with our own balance sheet. When you win, we win — and we build the infrastructure that lets talent move at the speed of the market." },
];

export const PROGRAMS = [
  { tag: "DISCRETIONARY", title: "Macro & Directional", body: "Firm capital for traders expressing high-conviction views across equities, rates and FX with dynamic risk allocation.", metric: "Up to $10M", metricLabel: "Buying power" },
  { tag: "SYSTEMATIC", title: "Quantitative Desk", body: "Research-driven strategies deployed on our low-latency infrastructure, with full quant and engineering support.", metric: "< 5ms", metricLabel: "Execution edge" },
  { tag: "DEVELOPMENT", title: "The Trainee Track", body: "A structured path from first fill to full mandate — mentorship, simulator capital and a clear route to the desk.", metric: "9 mo", metricLabel: "To live capital" },
];

export const TEAM = [
  { name: "Nathaniel Roe", role: "Founding Partner", img: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  { name: "Marcus Vale", role: "Head of Trading", img: "https://images.unsplash.com/photo-1453396450673-3fe83d2db2c4?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  { name: "Eleanor Shaw", role: "Chief Risk Officer", img: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  { name: "David Okonkwo", role: "Head of Quant", img: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
];

export const FAQ = [
  { q: "Do I need to put up my own capital?", a: "No. As a proprietary trading firm, we trade our own balance sheet. Approved traders are allocated firm capital and share in the performance they generate." },
  { q: "What experience is required to apply?", a: "We back talent at every stage — from seasoned desk traders to exceptional graduates entering through our Trainee Track. What matters most is discipline, curiosity and demonstrable edge." },
  { q: "Is the role remote or on-site?", a: "Our senior desks operate from our global offices, but we support hybrid arrangements for established traders with a proven track record." },
  { q: "How does the profit split work?", a: "Splits scale with your book size, consistency and risk-adjusted returns. We are structured so that the best traders keep the majority of what they produce." },
  { q: "How long does the application process take?", a: "Initial review takes under two weeks. Shortlisted candidates progress to a trading assessment and a conversation with the desk heads." },
];

export const INSIGHTS = [
  { cat: "MARKET STRUCTURE", date: "MAY 2026", title: "Why liquidity fragmentation rewards the patient desk", read: "6 min" },
  { cat: "RISK", date: "APR 2026", title: "Position sizing as a first-class strategy, not an afterthought", read: "8 min" },
  { cat: "CULTURE", date: "MAR 2026", title: "Building a trading floor that compounds talent", read: "5 min" },
];

// Add vacancy objects here to publish open roles. Each becomes a clickable
// card that pre-fills the application form with its title + capital_track.
// Example: { title: "Discretionary Macro Trader", desk: "Discretionary Desk",
//   location: "Mthatha / Hybrid", type: "Full-time", capital_track: "Discretionary Desk",
//   blurb: "Trade firm capital across equities, rates and FX." }
export const VACANCIES = [];
